export default function initDashboardToggleContent(): void {
    const $dashboardToggleContent = document.querySelectorAll<HTMLElement>('.js-dashboard-toggle-content');
    $dashboardToggleContent.forEach($container => {
        new DashboardToggleContent($container);
    });
}

class DashboardToggleContent {
    $el: HTMLElement | null | undefined;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.init();
    }

    init(): void {
        const forwardButton = this.$el?.querySelector('.js-forward-dashboard-content')
        const contentToShow = this.$el?.querySelector('.dashboard-content--hidden');
        const contentToHide = this.$el?.querySelector('.dashboard-content--active');
        const backButton = this.$el?.querySelector('.js-back-dashboard-content');

        forwardButton?.addEventListener('click', ()=> {
            contentToShow?.classList.remove('dashboard-content--hidden');
            contentToHide?.classList.add('dashboard-content--hidden');
            contentToHide?.classList.remove('dashboard-content--active');
            window.scrollTo(0, 0)
        })

        backButton?.addEventListener('click', ()=> {
            contentToShow?.classList.add('dashboard-content--hidden');
            contentToHide?.classList.remove('dashboard-content--hidden');
            window.scrollTo(0, 0)
        })
    }
}
